<template>
  <div>
    <b-alert v-if="myProjects.length === 0" show>
      {{$dt('dashboard.my_projects.no_project_pm','You are not a PM of any projects!')}}
    </b-alert>
    <b-list-group v-else class="project-list">
      <b-list-group-item v-for="p in myProjects" :key="p.id" class=" py-1 px-2">
        <b-link :to="{ name: 'ProjectHome', params: { jira_key:p.key } }">
          {{ p.name }}
        </b-link>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  mounted() {
    // this.getData();
  },
  props: {},
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('Auth', ['myProjects']),
  },
  methods: {
  }
};

// };
</script>
<style lang=scss>
.project-list,
.project-list .list-group-item {
  border-color: $gray;
}

.badge.percent-badge {
  background-color: $white;
  border: solid 1px $gray;
}
</style>
